export const isUSPSTokenExpired = () => {
    const expiry = localStorage.getItem('uspsTokenExpiry');
    console.log('Token expiry time:', expiry);
    return !expiry || Date.now() > Number(expiry);
};
  